import { GAEventAction, GAEventCategory } from '../google-tag-manager';

/**
 * GA utilities class
 */
export class GAUtil {

    public static gaEvent(category: string|GAEventCategory, action: string|GAEventAction, label?: string): void {
        if ((window as any).ga === undefined) {
            return undefined;
        }

        if (label === '' || label === undefined) {
            ga('send', {
                hitType: 'event',
                eventCategory: category,
                eventAction: action,
            });
        } else {
            ga('send', {
                hitType: 'event',
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
            });
        }
    }

    public static gaPageview(): void {
        if ((window as any).ga === undefined) {
            return undefined;
        }

        ga('set', 'page', location.pathname + location.search);
        ga('send', 'pageview');
    }

    public static gaPromo(id: string, name: string, creative: string, position: number): void {
        if ((window as any).ga === undefined) {
            return undefined;
        }
        ga('ec:addPromo', {
            'id': id,
            'name': name,
            'creative': creative,
            'position': position
        });
        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', name);
    }

    public static gaProductDetailView(eventId: string, name: string, selectionMethod: string, promoterId: string): void {
        if ((window as any).ga === undefined) {
            return undefined;
        }
        ga('ec:addProduct', {
            'id': eventId,
            'name': name,
            'dimension7': promoterId,
            'dimension8': selectionMethod
          });
          ga('ec:setAction', 'detail');
          ga('set', 'page', location.pathname);

          ga('send', 'pageview');
    }

    public static gaSetCustomDimension(name: string, content: string): void {
        if ((window as any).ga === undefined) {
            return undefined;
        }

        ga('set', name, content);
    }
}
